export const reportChatMenuError = ({ detail }: { detail: any }) => {
  try {
    window?.AegisV2?.error?.({
      msg: 'The chat menu uses the default menu.',
      reportType: 'chatMenuError',
    });

    const menuDetail = JSON.stringify(detail);
    window?.AegisV2?.error?.({
      msg: 'The chat menu uses the default menu.',
      reportType: 'chatMenuError',
      menuDetail,
    });
  } catch (e) {}
};

export const reportChatMenuEmpty = () => {
  window?.AegisV2?.error?.({
    msg: 'DescribeChatMenu api return empty.',
    reportType: 'chatMenuError',
  });
};

export const reportChatMenuSuccess = () => {
  window?.AegisV2?.info?.({
    msg: 'chat menus render successfully.',
    reportType: 'chatMenuSuccess',
  });
};

export const reportLogin = (
  state: 'fromCloud' | 'getTokenFormSass',
  options: any = {},
) => {
  try {
    const { saas_uin } = options || {};
    const ext = JSON.stringify(options);
    window?.AegisV2?.info?.({
      msg: 'aboutlogin',
      reportType: 'aboutLogin',
      state,
      uin: String(saas_uin || ''),
      ext,
    });
  } catch (e) {}
};
